<a class="skip-link" href="#main-content">Skip to main content</a>
<mat-toolbar color="primary" role="banner">
  <div class="toolbar-nav-toggle">
    <button
      type="button"
      class="nav-toggle"
      [attr.aria-label]="
        isNavCollapsed ? 'Expand navigation' : 'Collapse navigation'
      "
      [attr.aria-expanded]="!isNavCollapsed"
      aria-controls="app-sidenav"
      [matTooltip]="
        isNavCollapsed ? 'Expand navigation' : 'Collapse navigation'
      "
      matTooltipPosition="below"
      (click)="toggleNav($event)"
    >
      <mat-icon aria-hidden="true">menu</mat-icon>
    </button>
  </div>
  <img
    *ngIf="areShellFontsReady"
    src="../assets/images/wexlogo.png"
    class="toolbar-logo"
    alt=""
  />
  @if (!areShellFontsReady) {
    <app-skeleton
      class="skeleton-shape toolbar-logo-skeleton"
      aria-hidden="true"
    />
  }
  @if (areShellFontsReady) {
    <span class="toolbar-title">Risk Action Gateway</span>
    @if (environmentBadge; as badge) {
      <span
        class="environment-badge"
        [class.environment-badge-local]="badge.tone === 'local'"
        [class.environment-badge-dev]="badge.tone === 'dev'"
        [class.environment-badge-stage]="badge.tone === 'stage'"
      >
        {{ badge.label }}
      </span>
    }
  } @else {
    <app-skeleton
      class="skeleton-shape toolbar-title-skeleton"
      aria-hidden="true"
    />
  }
  @if (areShellFontsReady && !isLoading) {
    <button
      type="button"
      class="user-profile-button"
      [matMenuTriggerFor]="userMenu"
      [attr.aria-label]="'Open user menu for ' + userDisplayName"
    >
      <span class="user-avatar" aria-hidden="true">{{ userInitial }}</span>
      <span class="user-identity">
        <span class="user-name">{{ userDisplayName }}</span>
        @if (userEmail) {
          <span class="user-email">{{ userEmail }}</span>
        }
      </span>
      <mat-icon aria-hidden="true">keyboard_arrow_down</mat-icon>
    </button>
  } @else {
    <app-skeleton
      class="skeleton-shape toolbar-profile-skeleton"
      role="status"
      aria-label="Loading application header"
    />
  }
  <mat-menu #userMenu="matMenu" xPosition="before" class="user-menu-panel">
    <button type="button" mat-menu-item (click)="signOut()">
      <mat-icon aria-hidden="true">logout</mat-icon>
      <span>Logout</span>
    </button>
  </mat-menu>
</mat-toolbar>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    id="app-sidenav"
    class="sidenav"
    [class.menu-close]="isNavCollapsed"
    mode="side"
    opened="true"
    role="navigation"
    aria-label="Main navigation"
  >
    <div class="sidenav-inner">
      <mat-nav-list>
        @if (!areShellFontsReady || isLoading || (isNavLoading$ | async)) {
          <div class="nav-skeleton" role="status">
            <span class="shell-loading-label">Loading navigation</span>
            @for (row of [1, 2, 3, 4, 5, 6, 7, 8]; track row) {
              <div class="nav-skeleton-row" aria-hidden="true">
                <app-skeleton class="skeleton-shape nav-icon-skeleton" />
                @if (!isNavCollapsed) {
                  <app-skeleton class="skeleton-shape nav-label-skeleton" />
                }
              </div>
            }
          </div>
        } @else {
          @if (links$ | async; as links) {
            @for (link of links; track link.url) {
              <a
                mat-list-item
                [routerLink]="link.url"
                routerLinkActive="active"
                [ariaCurrentWhenActive]="'page'"
                #linkActive="routerLinkActive"
                [matTooltip]="isNavCollapsed ? link.name : ''"
                matTooltipPosition="right"
                [attr.aria-label]="isNavCollapsed ? link.name : null"
                *ngIf="link.isVisible && hasAccess(link.url)"
              >
                <span class="content">
                  <mat-icon
                    mat-list-icon
                    class="menu-item-icon"
                    aria-hidden="true"
                    [fontSet]="
                      linkActive.isActive
                        ? 'material-icons'
                        : 'material-icons-outlined'
                    "
                  >
                    {{ link.icon }}
                  </mat-icon>
                  <span class="menu-item-text">{{ link.name }}</span>
                </span>
              </a>
            }
          }
        }
      </mat-nav-list>
      <hr class="nav-separator" />
      <mat-nav-list class="nav-footer">
        <button
          type="button"
          mat-list-item
          class="logout-link"
          [matTooltip]="isNavCollapsed ? 'Logout' : ''"
          matTooltipPosition="right"
          [attr.aria-label]="isNavCollapsed ? 'Logout' : null"
          (click)="signOut()"
        >
          <span class="content">
            <mat-icon
              mat-list-icon
              class="menu-item-icon"
              fontSet="material-icons-outlined"
              aria-hidden="true"
              >logout
            </mat-icon>
            <span class="menu-item-text">Logout</span>
          </span>
        </button>
      </mat-nav-list>
    </div>
  </mat-sidenav>
  <mat-sidenav-content
    id="main-content"
    role="main"
    tabindex="-1"
    [class.menu-close]="isNavCollapsed"
  >
    <app-loading-bar />
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
